import { Link } from 'react-router-dom';

const Network = () => {
  const features = [
    {
      icon: "🏠",
      title: "Professionelle Ausstattung",
      items: [
        "Hochwertige Kameras: Für gestochen scharfe Aufnahmen.",
        "Multi-Streaming-Setup: Optimal für mehrere Plattformen gleichzeitig.",
        "Lichttechnik: Perfekte Ausleuchtung für jeden Raum."
      ]
    },
    {
      icon: "🏠",
      title: "Komfortables Wohnen",
      items: [
        "Vollmöblierte Apartments mit allem, was du für einen angenehmen Aufenthalt brauchst.",
        "Schnelles WLAN für reibungsloses Streaming.",
        "Stilvolle Einrichtung, die dich und deine Zuschauer begeistert."
      ]
    },
    {
      icon: "🏠",
      title: "Flexibilität & Erreichbarkeit",
      items: [
        "Wohnungen in vielen deutschen Städten – immer in deiner Nähe.",
        "Flexible Mietoptionen, egal ob für ein paar Tage, Wochen oder länger."
      ]
    }
  ];

  const benefits = [
    "Ruhe & Privatsphäre: Keine Ablenkungen – konzentriere dich voll auf deine Arbeit.",
    "Technische Unterstützung: Bei Problemen oder Fragen steht unser Team bereit.",
    "Günstige Konditionen: Wir bieten dir erschwingliche Preise für Premium-Apartments."
  ];

  const steps = [
    {
      title: "Anfrage stellen",
      description: "Teile uns mit, in welcher Stadt und für welchen Zeitraum du ein Apartment benötigst."
    },
    {
      title: "Einziehen & Durchstarten",
      description: "Genieße die voll ausgestattete Umgebung und produziere deinen Content."
    },
    {
      title: "Rundum-Betreuung",
      description: "Wir stehen dir während deines gesamten Aufenthalts zur Seite."
    }
  ];

  return (
    <div className="pt-20">
      {/* Hero Section */}
      <section className="relative py-20 lg:py-32 overflow-hidden">
        <div className="absolute inset-0 bg-gradient-to-b from-deep-black via-deep-black/95 to-deep-black -z-10"></div>
        <div className="absolute -top-1/2 right-0 w-3/4 h-full bg-gradient-to-bl from-hot-pink/20 to-accent-purple/20 blur-3xl animate-float"></div>
        <div className="absolute -bottom-1/2 left-0 w-3/4 h-full bg-gradient-to-tr from-neon-blue/20 to-hot-pink/20 blur-3xl animate-float" style={{ animationDelay: '-3s' }}></div>

        <div className="container-custom">
          <div className="max-w-4xl mx-auto text-center">
            <h1 className="text-4xl sm:text-5xl md:text-6xl lg:text-7xl font-black mb-6">
              Wohnnetzwerk – <span className="text-gradient">Dein Rückzugsort</span>
            </h1>
            <h2 className="text-2xl sm:text-3xl md:text-4xl font-playfair mb-8">
              Where <span className="text-hot-pink">Temptation</span> Meets <span className="text-accent-purple">Talent</span>
            </h2>
            <p className="text-lg sm:text-xl text-white/80 mb-8">
              Für viele Performer ist der richtige Raum entscheidend für den Erfolg. 
              Deshalb haben wir ein deutschlandweites Studio-Wohnnetzwerk geschaffen, 
              das dir die perfekte Umgebung für deine Arbeit bietet.
            </p>
          </div>
        </div>
      </section>

      {/* What is our Network Section */}
      <section className="py-20 bg-gradient-to-b from-deep-black to-deep-black/95">
        <div className="container-custom">
          <div className="max-w-4xl mx-auto">
            <div className="relative">
              <div className="absolute -inset-1 bg-gradient-to-r from-hot-pink to-accent-purple rounded-3xl blur opacity-25"></div>
              <div className="relative glass-effect rounded-2xl p-8 sm:p-12">
                <h2 className="text-3xl sm:text-4xl font-playfair text-gradient mb-6">Was ist unser Wohnnetzwerk?</h2>
                <p className="text-lg text-white/80">
                  Unser Wohnnetzwerk besteht aus modernen, komplett ausgestatteten Apartments, 
                  die speziell auf die Bedürfnisse von Webcam-Performern zugeschnitten sind. 
                  Du kannst dich auf ein professionelles Streaming-Setup und eine entspannte 
                  Atmosphäre verlassen – ideal, um deinen Content auf das nächste Level zu bringen.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Features Section */}
      <section className="py-20 bg-gradient-to-b from-deep-black/95 to-deep-black">
        <div className="container-custom">
          <h2 className="text-3xl sm:text-4xl font-playfair text-center mb-12">
            Was bieten unsere <span className="text-gradient">Apartments?</span>
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            {features.map((feature, index) => (
              <div key={index} className="feature-card">
                <div className="text-4xl mb-6">{feature.icon}</div>
                <h3 className="text-xl sm:text-2xl font-playfair text-gradient mb-4">{feature.title}</h3>
                <ul className="space-y-3">
                  {feature.items.map((item, idx) => (
                    <li key={idx} className="flex items-start gap-3">
                      <span className="text-hot-pink">✦</span>
                      <span className="text-white/80">{item}</span>
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Benefits Section */}
      <section className="py-20 bg-gradient-to-b from-deep-black to-deep-black/95">
        <div className="container-custom">
          <div className="max-w-4xl mx-auto">
            <h2 className="text-3xl sm:text-4xl font-playfair text-center mb-12">
              Vorteile unseres <span className="text-gradient">Wohnnetzwerks</span>
            </h2>
            <div className="space-y-6">
              {benefits.map((benefit, index) => (
                <div key={index} className="glass-effect rounded-xl p-6 hover:scale-105 transition-transform duration-300">
                  <div className="flex items-start gap-4">
                    <span className="text-hot-pink text-xl">✅</span>
                    <p className="text-white/80 text-lg">{benefit}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* How it Works Section */}
      <section className="py-20 bg-gradient-to-b from-deep-black/95 to-deep-black">
        <div className="container-custom">
          <h2 className="text-3xl sm:text-4xl font-playfair text-center mb-12">
            Wie <span className="text-gradient">funktioniert</span> es?
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            {steps.map((step, index) => (
              <div key={index} className="relative group">
                <div className="absolute -inset-1 bg-gradient-to-r from-hot-pink to-accent-purple rounded-2xl blur opacity-25 group-hover:opacity-75 transition duration-1000"></div>
                <div className="relative glass-effect rounded-xl p-6 h-full">
                  <div className="text-4xl font-black text-gradient mb-4">{String(index + 1).padStart(2, '0')}</div>
                  <h3 className="text-xl font-playfair text-white mb-3">{step.title}</h3>
                  <p className="text-white/80">{step.description}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Call to Action */}
      <section className="py-20 bg-gradient-to-b from-deep-black to-deep-black/95">
        <div className="container-custom">
          <div className="relative max-w-4xl mx-auto">
            <div className="absolute -inset-1 bg-gradient-to-r from-hot-pink to-accent-purple rounded-3xl blur opacity-25"></div>
            <div className="relative glass-effect rounded-2xl p-8 sm:p-12 text-center">
              <h2 className="text-2xl sm:text-3xl font-playfair text-gradient mb-6">
                Bereit für dein neues Studio?
              </h2>
              <p className="text-lg sm:text-xl text-white/80 mb-8">
                Werde Teil unseres Netzwerks und starte in einem professionellen Umfeld durch!
              </p>
              <Link to="/bewerbung" className="btn-primary">
                JETZT BEWERBEN
              </Link>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Network;
